export default function FinancialFooter() {
  return (
    <footer className="w-full bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 border-t border-slate-700 pt-12 pb-16 md:pb-24 lg:pb-32 px-4 sm:px-6 font-mono">

      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-10 md:gap-16">

        {/* Marca */}
        <div className="text-center md:text-left">
          <h2 className="text-lg sm:text-xl md:text-2xl font-extrabold tracking-widest uppercase text-emerald-400">
            Terminal Financiera
          </h2>

          <p className="text-[10px] sm:text-xs text-slate-500 tracking-widest mt-2">
            Trading • Mercados Globales • Cripto
          </p>
        </div>

        {/* Exchanges */}
        <div className="flex flex-col sm:flex-row items-center gap-6 sm:gap-12">

          {/* Binance */}
          <a
            href="https://www.binance.com/referral/earn-together/refer2earn-usdc/claim?hl=en&ref=GRO_28502_IH3NC&utm_source=default"
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center group transition-all duration-300"
          >
            <span className="text-yellow-400 font-bold text-base sm:text-lg md:text-xl tracking-widest group-hover:scale-110 transition">
             Binance
            </span>

            <span className="text-[10px] sm:text-xs text-slate-500 mt-1">
              Bono de bienvenida
            </span>
          </a>

          {/* BingX */}
          <a
            href="https://bingxdao.com/invite/EQS2YS/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center group transition-all duration-300"
          >
            <span className="text-cyan-400 font-extrabold text-base sm:text-lg md:text-xl tracking-widest group-hover:scale-110 transition">
              BingX
            </span>

            <span className="text-[10px] sm:text-xs text-slate-500 mt-1">
              Futuros & Copy Trading
            </span>
          </a>

        </div>

        {/* Derechos */}
        <div className="text-[10px] sm:text-xs text-slate-500 tracking-widest text-center md:text-right">
          © {new Date().getFullYear()} Terminal Financiera  
          <br />
          <span className="text-slate-400">
            Hecho por{" "}
            <a
              href="https://www.codenofrontier.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-emerald-400 hover:text-emerald-300 transition"
            >
              Codenofrontier
            </a>
          </span>
        </div>

      </div>
    </footer>
  );
}